import { useEffect, useState } from 'react'
import streamConfig from 'consts/streamConfig';
import { getStream } from 'utils/streamUtils';


const useStream = (constraints:MediaStreamConstraints = streamConfig) => {
  const [stream, setStream] = useState<MediaStream|null>(null);
  useEffect(() => {
    (async ()=> {
      setStream(await getStream(constraints));
    })();
  }, [constraints])
  return stream;
}

export default useStream;